import * as React from 'react';
import * as Redux from 'react-redux';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  FormHelperText,
} from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import {
  alertNivelesAcademicos,
  saveNivelesAcademicosAction,
} from '../NivelesAcademicosAction';
import { validMessage } from '../../../../constants/ValidsFormConst';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import AlertWidget from '../../../../widgets/AlertMsg';
import { ALERT_FORM_NIVELES_ACADEMICOS } from '../NivelesAcademicosReducer';
import { useNotification } from '../../../../helpers/Notification';

const FormNivelesAcademicos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const nivelesAcademicosStore = Redux.useSelector(
    (state) => state.nivelesAcademicos,
  );

  const activo = nivelesAcademicosStore.activo;

  const initData = {
    nombre: '',
    numero: 1,
    abrev: 1,
    siglas: 'RO',
    categoria: 'MEDIA', // MEDIA - TECNICA
    tipoNivelAcademico: null,
    desc: '',
    estatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    numero: false,
    abrev: false,
    siglas: false,
    categoria: false,
    tipoNivelAcademico: false,
    estatus: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(() => setData(values), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (entidadesStore.activo === undefined || entidadesStore.activo === null) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveNivelesAcademicosAction(
        { dispatch, notify },
        entidadesStore.activo.id,
        activo?.id,
        data,
        nivelesAcademicosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(CONST.nombre.name, e.target.value)
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            id={CONST.numero.name}
            required
            label={CONST.numero.label}
            value={data.numero}
            onChange={(e) =>
              _handleSetDataField(CONST.numero.name, Number(e.target.value))
            }
            helperText={dataError.numero ? validMessage.required : null}
            error={dataError.numero}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            id={CONST.abrev.name}
            required
            label={CONST.abrev.label}
            value={data.abrev}
            onChange={(e) =>
              _handleSetDataField(CONST.abrev.name, e.target.value)
            }
            helperText={dataError.abrev ? validMessage.required : null}
            error={dataError.abrev}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            id={CONST.siglas.name}
            required
            label={CONST.siglas.label}
            value={data.siglas}
            onChange={(e) =>
              _handleSetDataField(CONST.siglas.name, e.target.value)
            }
            helperText={dataError.siglas ? validMessage.required : null}
            error={dataError.siglas}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            size="small"
            required
            error={dataError.categoria}
          >
            <InputLabel id={`label_${CONST.categoria.name}`}>
              {CONST.categoria.label}
            </InputLabel>
            <Select
              id={CONST.categoria.name}
              value={data.categoria}
              labelId={`label_${CONST.categoria.name}`}
              label={CONST.categoria.label}
              required
              onChange={(e) =>
                _handleSetDataField(
                  CONST.categoria.name,
                  Number(e.target.value),
                )
              }
            >
              <MenuItem value="MEDIA">MEDIA</MenuItem>
              <MenuItem value="TECNICA">TÉCNICA</MenuItem>
            </Select>
            {dataError.categoria ? (
              <FormHelperText>{validMessage.required}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            size="small"
            required
            error={dataError.tipoNivelAcademico}
          >
            <InputLabel id={`label_${CONST.tipoNivelAcademico.name}`}>
              {CONST.tipoNivelAcademico.label}
            </InputLabel>
            <Select
              id={CONST.tipoNivelAcademico.name}
              value={data.tipoNivelAcademico}
              required
              labelId={`label_${CONST.tipoNivelAcademico.name}`}
              label={CONST.tipoNivelAcademico.label}
              onChange={(e) =>
                _handleSetDataField(
                  CONST.tipoNivelAcademico.name,
                  Number(e.target.value),
                )
              }
            >
              <MenuItem value="EDUCACION_INICIAL">EDUCACION INICIAL</MenuItem>
              <MenuItem value="EDUCACION_BASICA">EDUCACION BASICA</MenuItem>
              <MenuItem value="EDUCACION_MEDIA_TECNICA">
                EDUCACION MEDIA TECNICA
              </MenuItem>
              <MenuItem value="EDUCACION_JOVENES_ADULTOS">
                EDUCACION JOVENES ADULTOS
              </MenuItem>
              <MenuItem value="EDUCACION_SUPERIOR">EDUCACION SUPERIOR</MenuItem>
            </Select>
            {dataError.tipoNivelAcademico ? (
              <FormHelperText>{validMessage.required}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.estatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.name, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            green
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormNivelesAcademicos;
